import HTTP from '@/api/HTTP';
import transformerBonStock from '@/services/bonStock/filters/bonStockServerTableDataTransformer';

const URL_BASE = 'gescom/BonStock/';

export async function getAll(bonStockFilter) {
  const inputServer = transformerBonStock(bonStockFilter);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function get(bonStockId) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: bonStockId } });
  return response;
}
export async function getByLigneCommandeId(bonStockId) {
  const response = await HTTP.get(URL_BASE + 'GetByLigneCommandeIdAsync', { params: { id: bonStockId } });
  return response;
}

export async function archiver(id, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { ids: [id], archiver: status });
  return response;
}
export async function create(bonStock) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', bonStock);
  return response;
}

export async function createAll(bonStocks, modeTest) {
  const mode = modeTest ? '?modeTest=true' : '?modeTest=false';
  const response = await HTTP.post(URL_BASE + 'CreateAllAsync' + mode, bonStocks);
  return response;
}

export async function update(bonStock) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', bonStock);
  return response;
}

export async function remove(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id } });
  return response;
}

export async function archiverAll(ids, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { ids: ids, archiver: status });
  return response;
}

export async function transferStockAsync(query) {
  const response = await HTTP.post(URL_BASE + 'TransferStockAsync', query);
  return response;
}
